export const BUDGET_PERIOD_OPTIONS = [
  { value: 'annual', label: '年度' },
  { value: 'quarterly', label: '季度' },
  { value: 'monthly', label: '月度' }
];

/** 预算类别管理：新建/筛选可选周期（不含月度） */
export const BUDGET_CATEGORY_PERIOD_OPTIONS = BUDGET_PERIOD_OPTIONS.filter(
  (o) => o.value !== 'monthly'
);

export const BUDGET_PERIOD_LABEL = Object.fromEntries(
  BUDGET_PERIOD_OPTIONS.map((o) => [o.value, o.label])
);

export const BUDGET_LEDGER_CHANGE_TYPE_LABEL = {
  import: '批量导入',
  manual: '手动维护',
  adjustment: '预算调整',
  freeze: '冻结',
  unfreeze: '解冻',
  consume: '扣减',
  reset: '重置'
};

export const BUDGET_LEDGER_SOURCE_TYPE_LABEL = {
  manual: '手动维护',
  import: '批量导入',
  budget_adjustment: '预算调整',
  exp_claim: '费用报销',
  exp_prepayment: '预付款',
  exp_prepayment_writeoff: '预付款/借款核销',
  exp_prepayment_adjust: '预付款调整'
};

/** 按变更类型取「本条实际变动的金额」：冻结/解冻看 frozen_delta，扣减看 used_delta，其余看 amount_delta */
export function resolveLedgerDelta(row) {
  const changeType = String(row?.change_type || '').trim();
  if (changeType === 'freeze' || changeType === 'unfreeze') {
    const amount = Number(row?.frozen_delta);
    if (!Number.isFinite(amount) || amount === 0) return null;
    return {
      label: changeType === 'freeze' ? '冻结' : '解冻',
      amount,
      absAmount: Math.abs(amount)
    };
  }
  if (changeType === 'consume') {
    const amount = Number(row?.used_delta);
    if (!Number.isFinite(amount) || amount === 0) return null;
    return { label: '扣减', amount, absAmount: Math.abs(amount) };
  }
  const amount = Number(row?.amount_delta);
  if (!Number.isFinite(amount) || amount === 0) return null;
  return { label: '总额', amount, absAmount: Math.abs(amount) };
}

export function formatLedgerBalanceAfter(row) {
  const total = Number(row?.amount_total_after);
  const used = Number(row?.amount_used_after);
  const frozen = Number(row?.amount_frozen_after);
  if (![total, used, frozen].every(Number.isFinite)) return null;
  const available = Math.round((total - used - frozen) * 100) / 100;
  return {
    total,
    used,
    frozen,
    available,
    text: `总额 ${formatBudgetMoney(total)} · 已用 ${formatBudgetMoney(used)} · 冻结 ${formatBudgetMoney(frozen)} · 可用 ${formatBudgetMoney(available)}`
  };
}

export function formatBudgetMoney(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : '0.00';
}

export function renderBudgetMoney(value) {
  return `¥${formatBudgetMoney(value)}`;
}
